<template>
    <div class="step-indicator">
        <IndicatorItem
        v-for="(item, index) in tolalIndicators"
        :key="index"
        :indicatorNumber = index
        :stepNumber = numberIndicator
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import IndicatorItem from '@/components/game/IndicatorItem.vue'

export default {
    name: 'StepIndicator',
    components:{
        IndicatorItem
    },
    computed: {
        ...mapGetters([
            'stepNumber',
            'actualView',
            'tolalIndicators',
            'numberIndicator'
        ])
    }    
}
</script>

<style>
    
</style>